module.exports = __webpack_public_path__ + "static/media/bruxelles.d80d7ba3.jpg";